import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as contractActions from "../../../actions/contractActions";
import * as userActions from "../../../actions/userActions";
import * as modalActions from "../../../actions/modalActions";

import HeaderWrapper from "../../common/HeaderWrapper";
import Modal from "../../common/Modal";
import ConfirmModal from "../../common/ConfirmModal";
import ContractNoteForm from "./ContractNoteForm";
import ContractNoteList from "./ContractNoteList";

class ContractNotes extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      note: {},
      adding: false
    };
  }

  componentDidMount = () => {
    this.props.actions.getContract(this.props.match.params.id);
  };

  onClickAdd = () => {
    this.setState({ note: {}, adding: true });
    this.props.actions.showModalSuccess("contractDetailsModal");
  };

  onClickEdit = (noteId) => {
    const { contract } = this.props;
    const note = contract.notes.find((n) => n._id === noteId);
    this.setState({ note, adding: false });
    this.props.actions.showModalSuccess("contractDetailsModal");
  };

  onClickDelete = (noteId) => {
    this.props.actions.requestNoteId(noteId);
  };

  handleAdd = (contract, note) => {
    this.props.actions.createNote(contract, note);
  };

  handleUpdate = (note) => {
    const { contract } = this.props;
    this.props.actions.updateNote(contract._id, note);
  };

  handleDelete = () => {
    const { contract, contractNoteToDelete } = this.props;
    this.props.actions.deleteNote(contract._id, contractNoteToDelete);
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { contract, isMobile, auth } = this.props;
    const { note, adding } = this.state;

    const noteForm = (
      <ContractNoteForm
        contract={contract}
        note={note}
        adding={adding}
        onAdd={this.handleAdd}
        onSave={this.handleUpdate}
        onCancel={this.props.actions.hideModal}
        saving={this.props.saving}
        auth={auth}
      />
    );

    return (
      <>
        <HeaderWrapper
          breadcrumbs={[{ label: contract.name }, { label: "Notes" }]}
          onClickEdit={this.handleEdit}
          onClickAdd={this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <div className="content-wrapper transparent">
          <ContractNoteList
            contract={contract}
            isMobile={isMobile}
            search={this.state.search}
            onClickEdit={this.onClickEdit}
            onClickDelete={this.onClickDelete}
          />
          <Modal
            id="contractDetailsModal"
            title={adding ? "Add Note" : "Edit Note"}
            body={noteForm}
            close={this.props.actions.hideModal}
          />
          <ConfirmModal
            id="noteDeleteModal"
            title="Delete Note"
            body="Are you sure you want to delete this note?"
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </>
    );
  }
}

ContractNotes.propTypes = {
  actions: PropTypes.object.isRequired,
  contract: PropTypes.object,
  match: PropTypes.object,
  params: PropTypes.object,
  contractNoteToDelete: PropTypes.string,
  isMobile: PropTypes.bool,
  saving: PropTypes.bool,
  auth: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    saving: state.reducers.savingContract,
    contract: state.reducers.contract,
    contractNoteToDelete: state.reducers.contractNoteToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...contractActions,
        ...userActions,
        ...modalActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ContractNotes);
